import React from "react";
import { works_in_franchise } from "../../../Functionalities/Config";

function RestaurantChargesSection({
  data,
  setData,
  commission,
  setCommission,
  updateRestaurantCharge,
  baseDeliveryCharge,
  gstCharge,
  addExtraCommission,
  ManageRestaurant,
  showMessage,
}) {
  return (
    <div style={{ backgroundColor: "white", borderRadius: 20 }}>
      {/* Commission Percentage */}
      <div style={{ backgroundColor: "white", borderRadius: 20 }}>
        <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0">
          <div className="mr-auto pr-3">
            <h4 className="text-black fs-20">Commission Percentage</h4>
          </div>
        </div>
        <div className="card-body">
          <div className="basic-form mb-2">
            <form action="#">
              <div className="input-group ">
                <div className="dropdown bootstrap-select default-select">
                  <input
                    type="number"
                    min={0}
                    className="form-control"
                    disabled={
                      !(
                        works_in_franchise
                      )
                    }
                    placeholder="Commission"
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                    value={commission.commission}
                    onChange={(e) => {
                      setCommission({
                        ...commission,
                        commission: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="ml-4">
                  {works_in_franchise && (
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                        if (commission.commission === "") {
                          showMessage(
                            "Please enter a commission percentage",
                            "danger",
                            "Error!",
                            "top",
                            "top-right",
                            0
                          );
                          return;
                        }
                        let result = ManageRestaurant(e, commission, "patch");
                        result
                          .then((result) => {
                            if (result.data.Status === true) {
                              showMessage(
                                "Commission updated",
                                "success",
                                "Success!",
                                "top",
                                "top-right",
                                0
                              );
                            } else {
                              showMessage(
                                "Commission update failed",
                                "danger",
                                "Failed!",
                                "top",
                                "top-right",
                                0
                              );
                            }
                          })
                          .catch((err) => {
                            showMessage(
                              err.toString(),
                              "danger",
                              "Error!",
                              "top",
                              "top-right",
                              0
                            );
                          });
                      }}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Restaurant Extra Charge */}
      <div style={{ backgroundColor: "white", borderRadius: 20 }}>
        <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0">
          <div className="mr-auto pr-3">
            <h4 className="text-black fs-20">Restaurant Extra Charge</h4>
          </div>
        </div>
        <div className="card-body">
          <div className="basic-form mb-2">
            <form action="#">
              <div className="input-group ">
                <div className="dropdown bootstrap-select default-select">
                  <input
                    type="number"
                    min={0}
                    className="form-control"
                    disabled={
                      !(
                        works_in_franchise
                      )
                    }
                    placeholder="Extra charge"
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                    value={data.restaurent_charge}
                    onChange={(e) => {
                      setData({
                        ...data,
                        restaurent_charge: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="ml-4">
                  {works_in_franchise && (
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                        if (data.restaurent_charge === "") {
                          showMessage(
                            "Please enter a restaurant charge",
                            "danger",
                            "Error!",
                            "top",
                            "top-right",
                            0
                          );
                          return;
                        }
                        updateRestaurantCharge();
                      }}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Restaurant Base Delivery Charge */}
      <div style={{ backgroundColor: "white", borderRadius: 20 }}>
        <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0">
          <div className="mr-auto pr-3">
            <h4 className="text-black fs-20">
              Restaurant Base Delivery Charge
            </h4>
          </div>
        </div>
        <div className="card-body">
          <div className="basic-form mb-2">
            <form action="#">
              <div className="input-group ">
                <div className="dropdown bootstrap-select default-select">
                  <input
                    type="number"
                    min={0}
                    className="form-control"
                    disabled={
                      !(
                        works_in_franchise
                      )
                    }
                    placeholder="Extra charge"
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                    value={data.base_delivery_charge}
                    onChange={(e) => {
                      setData({
                        ...data,
                        base_delivery_charge: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="ml-4">
                  {works_in_franchise && (
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                        if (data.base_delivery_charge === "") {
                          showMessage(
                            "Please enter base delivery charge",
                            "danger",
                            "Error!",
                            "top",
                            "top-right",
                            0
                          );
                          return;
                        }
                        baseDeliveryCharge();
                      }}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Restaurant GST Charge */}
      <div style={{ backgroundColor: "white", borderRadius: 20 }}>
        <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0">
          <div className="mr-auto pr-3">
            <h4 className="text-black fs-20">Restaurant GST Charge</h4>
          </div>
        </div>
        <div className="card-body">
          <div className="basic-form mb-2">
            <form action="#">
              <div className="input-group ">
                <div className="dropdown bootstrap-select default-select">
                  <input
                    type="number"
                    min={0}
                    className="form-control"
                    disabled={
                      !(
                        works_in_franchise
                      )
                    }
                    placeholder="Extra charge"
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                    value={data.gst_charge}
                    onChange={(e) => {
                      setData({
                        ...data,
                        gst_charge: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="ml-4">
                  {works_in_franchise && (
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                        if (data.gst_charge === "") {
                          showMessage(
                            "Please enter gst charge",
                            "danger",
                            "Error!",
                            "top",
                            "top-right",
                            0
                          );
                          return;
                        }
                        gstCharge();
                      }}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Restaurant Extra Commission */}
      <div style={{ backgroundColor: "white", borderRadius: 20 }}>
        <div className="card-header d-sm-flex flex-wrap d-block pb-0 border-0">
          <div className="mr-auto pr-3">
            <h4 className="text-black fs-20">Restaurant Extra Commission</h4>
          </div>
        </div>
        <div className="card-body">
          <div className="basic-form mb-2">
            <form action="#">
              <div className="input-group ">
                <div className="dropdown bootstrap-select default-select">
                  <input
                    type="number"
                    min={0}
                    className="form-control"
                    disabled={
                      !(
                        works_in_franchise
                      )
                    }
                    placeholder="Extra charge"
                    onWheelCapture={(e) => {
                      e.target.blur();
                    }}
                    onKeyDown={(evt) =>
                      ((evt.key === "e" || evt.key === "-") &&
                        evt.preventDefault()) ||
                      (evt.key === "E" && evt.preventDefault())
                    }
                    value={data.extra_commission}
                    onChange={(e) => {
                      setData({
                        ...data,
                        extra_commission: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="ml-4">
                  {works_in_franchise && (
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={(e) => {
                        e.preventDefault();
                        if (data.extra_commission === "") {
                          showMessage(
                            "Please enter extra commission charge",
                            "danger",
                            "Error!",
                            "top",
                            "top-right",
                            0
                          );
                          return;
                        }
                        addExtraCommission();
                      }}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RestaurantChargesSection;
